import {
  ComboProductStructure,
  DisplayedComboProductStructure, emptyOverride,
  OverrideInstruction,
  OverridePositionRequest, OverridePositionsMap,
  PositionTypeEnum
} from 'app/models/menu.model';
import { getComboStructurePositionId, MenuOverrideService } from 'app/services/menu-override.service';

export function buildOverridePositionRequest (
  menuSectionId: string,
  comboProductId: string,
  externalItemId: string,
  itemSizeId: string,
  overridePositionsMap: OverridePositionsMap,
  comboProductStructure: DisplayedComboProductStructure,
  initialComboProduct: DisplayedComboProductStructure,
  originalComboProduct: ComboProductStructure,
  ): OverridePositionRequest {
  let isOverrideExists = false;

  const positionId = getComboStructurePositionId(comboProductId, externalItemId, itemSizeId);

  let productOverridePosition = overridePositionsMap.getOverride(PositionTypeEnum.ComboProductStructure, positionId);

  if (!productOverridePosition) {
    productOverridePosition = {
      positionType: PositionTypeEnum.ComboProductStructure,
      positionId: positionId,
      override: emptyOverride,
      menuSectionId: menuSectionId,
    };
  } else {
    // if override position exists update it anyway no matter has changes or not
    isOverrideExists = true;
  }

  const overrideInstructions: OverrideInstruction[] = []

  if (initialComboProduct.isHidden != comboProductStructure.isHidden ) {
    MenuOverrideService.overrideBooleanFiled(initialComboProduct, originalComboProduct, 'isHidden', comboProductStructure.isHidden, isOverrideExists, overrideInstructions);
  }

  if (initialComboProduct.price != comboProductStructure.price) {
    MenuOverrideService.overrideNumberFiled(initialComboProduct, originalComboProduct, 'price', comboProductStructure.price, isOverrideExists, overrideInstructions);
  }

  return {
    ...productOverridePosition,
    instructions: overrideInstructions
  };
}

export function hasChangeComboStructure(
  comboProductStructure: DisplayedComboProductStructure,
  initialComboProduct: ComboProductStructure)
{
  return initialComboProduct.isHidden != comboProductStructure.isHidden || initialComboProduct.price != comboProductStructure.price;
}
